import {LoadingSpinner} from "./LoadingSpinner";
import React from "react";

export const AuthLoadingSpinner = () => {

    return (
        <div className="account-tab-container px-2 py-3 rounded-5 shadow-sm" id="email-verified">
            <div className="account-tab-content">
                <div className="fa-flex-col align-items-center justify-content-center w-100 h-100">
                    <LoadingSpinner theme="light"/>
                </div>
            </div>
        </div>
    )
}